import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: Array<'authenticated' | 'systemAdmin' | 'familyAdmin'>;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles = ['authenticated'] }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const isAllowed = allowedRoles.some((role) => {
    if (role === 'authenticated') return true;
    if (role === 'systemAdmin') return user?.isAdmin === true;
    if (role === 'familyAdmin') return user?.isFamilyAdmin === true;
    return false;
  });

  if (!isAllowed) {
    return <Navigate to="/family-tree" replace />;
  }

  return <>{children}</>;
};
